import Evaporate from 'evaporate'
import SparkMD5 from 'spark-md5'
import { sha256 } from 'js-sha256'
import NrSentry from '../utils/nr_sentry'
import API from '../vue_shared/api.js'

const initEvaporate = {
  data() {
    return {
      s3UploadConfig: null,
      evaporate: null
    }
  },

  mounted() {
    API.getS3UploadConfig().then((response: any) => {
      this.s3UploadConfig = response.data
      this.setupEvaporateFileUploader(response.data)
    })
  },

  methods: {
    setupEvaporateFileUploader(s3UploadConfig: any): void {
      Evaporate.create({
        aws_key: s3UploadConfig.multipart_upload_key_id, // Required
        bucket: s3UploadConfig.bucket, // Required
        awsRegion: s3UploadConfig.aws_region, // Defaults to us-east-1
        signerUrl: '/aws_signature', // Required
        awsSignatureVersion: '4',
        // partSize - 20 MB per part. AWS's 10,000 part maximum means max upload size is 195 GB.
        partSize: 20 * 1024 * 1024,
        sendCanonicalRequestToSignerUrl: true,
        onlyRetryForSameFileName: true,
        computeContentMd5: true,
        mockLocalStorage: true,

        cryptoMd5Method: (data: ArrayBuffer) => {
          return btoa(SparkMD5.ArrayBuffer.hash(data, true))
        },

        cryptoHexEncodedHash256: (data: ArrayBuffer | string) => {
          return sha256(data)
        }
      })
        .then((evaporate: any) => {
          // set state so we know Evaporate.js is ready to upload docs to S3
          this.evaporate = evaporate
        })
        .catch((e: any) => {
          // Error constructor with cause is not supported in older environments
          const nrError = new Error('Evaporate.create failed')
          ;(nrError as any).cause = e
          NrSentry.captureError(nrError)
        })
    }
  }
}

export default initEvaporate
